import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("my_tasks.do_update"))),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "btn-inca-secondary",
                  attrs: {
                    rounded: "",
                    outlined: "",
                    disabled: !_vm.isButtonDownloadHidden,
                  },
                  on: { click: _vm.openModal },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-user_add"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("my_tasks.assign_operator"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("btns.filter"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(
                  VCardText,
                  { staticClass: "pa-0" },
                  [
                    _c(VDataTable, {
                      key: _vm.key_table,
                      staticClass: "table-inca",
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.tablas,
                        "show-select": "",
                        "disable-pagination": "",
                        "hide-default-footer": "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.enterSelect()
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item.tableReference.tableId",
                          fn: function (row) {
                            return [
                              _c("div", { staticClass: "text-left" }, [
                                _c("b", { staticClass: "table-name" }, [
                                  _vm._v(
                                    _vm._s(row.item.tableReference.tableId)
                                  ),
                                ]),
                                _c("br"),
                                _c(
                                  "a",
                                  {
                                    staticClass: "compose-name",
                                    attrs: { title: row.item.id },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("joinTableReference")(
                                          row.item.tableReference
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.creationTime",
                          fn: function (row) {
                            return [
                              _c("span", { staticClass: "ml-4" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatDate")(row.item.creationTime)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.numRows",
                          fn: function (row) {
                            return [
                              _c("span", { staticClass: "date-format ml-3" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatNumber")(row.item.numRows)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.selected,
                        callback: function ($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("pagination-catalog", {
              key: _vm.key_pagination,
              attrs: { pagination: _vm.pagination },
              on: { changePagina: _vm.changePagina },
            }),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(
                      VCardTitle,
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            _vm.collapse_filter = !_vm.collapse_filter
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("my_tasks.search_filters")))]
                    ),
                    _c(
                      VCardText,
                      [
                        _c(VRow, { attrs: { dense: "" } }, [
                          _c(
                            "div",
                            { staticClass: "col-md-12" },
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: _vm.$t("my_tasks.search_operator"),
                                  placeholder: _vm.$t(
                                    "my_tasks.search_operator"
                                  ),
                                  small: "",
                                  dense: "",
                                  outlined: "",
                                  hint: "(Campo obligatorio)",
                                  "persistent-hint": "",
                                  rules: [
                                    function (v) {
                                      return (
                                        /[a-z0-9]+@[a-z]+.[a-z]{2,3}.[a-z]{2,3}/.test(
                                          v
                                        ) ||
                                        _vm.$t("my_tasks.modals.email_invalid")
                                      )
                                    },
                                  ],
                                },
                                model: {
                                  value: _vm.inputSearch,
                                  callback: function ($$v) {
                                    _vm.inputSearch = $$v
                                  },
                                  expression: "inputSearch",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-12" },
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: _vm.$t("my_tasks.search_table"),
                                  placeholder: _vm.$t("my_tasks.search_table"),
                                  small: "",
                                  dense: "",
                                  outlined: "",
                                },
                                model: {
                                  value: _vm.search.table,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.search, "table", $$v)
                                  },
                                  expression: "search.table",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-12" },
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: _vm.$t("my_tasks.search_zone"),
                                  placeholder: _vm.$t("my_tasks.search_zone"),
                                  small: "",
                                  dense: "",
                                  outlined: "",
                                },
                                model: {
                                  value: _vm.search.zone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.search, "zone", $$v)
                                  },
                                  expression: "search.zone",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-12" },
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: _vm.$t("my_tasks.search_domain"),
                                  placeholder: _vm.$t("my_tasks.search_domain"),
                                  small: "",
                                  dense: "",
                                  outlined: "",
                                },
                                model: {
                                  value: _vm.search.domain,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.search, "domain", $$v)
                                  },
                                  expression: "search.domain",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-12" },
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: _vm.$t("my_tasks.search_subdomain"),
                                  placeholder: _vm.$t(
                                    "my_tasks.search_subdomain"
                                  ),
                                  small: "",
                                  dense: "",
                                  outlined: "",
                                },
                                model: {
                                  value: _vm.search.subdomain,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.search, "subdomain", $$v)
                                  },
                                  expression: "search.subdomain",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-12 text-right" },
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "default mr-1",
                                  attrs: { outlined: "" },
                                  on: { click: _vm.onLimpiar },
                                },
                                [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                              ),
                              _c(
                                VBtn,
                                {
                                  staticClass: "primary",
                                  on: {
                                    click: function ($event) {
                                      return _vm.sendToSearch(_vm.inputSearch)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("btns.search")))]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_NAME_ALL_OWNER,
          attrs: { title: _vm.$t("my_tasks.assign_operator"), width: 700 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-assign-temporal-owner", {
                ref: _vm.MODAL_NAME_ALL_OWNER + "_body",
                attrs: {
                  relativeResourceNames: _vm.relativeResourceNames,
                  fromEmail: _vm.fromEmail,
                  isForAllOwners: true,
                },
                on: {
                  submit: _vm.assignTableByDataOperator,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_ALL_OWNER].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.MODAL_NAME_ALL_OWNER + "_body"].onSubmit(
                        $event
                      )
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { icon: "" } }, [
                    _vm._v("mdi-check-all "),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.assign"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }